import { ClientApp } from "models";
import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";
import { withRouter } from "react-router-dom";
import { Dispatch } from "redux";
import { State } from "redux/state";
import {
    Breadcrumbs,
    BreadcrumbsDispatchProps as DispatchProps,
    BreadcrumbsOwnProps as OwnProps,
    BreadcrumbsStateProps as StateProps
} from "../components/Breadcrumbs";


const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = (dispatch: Dispatch) => ({});

const mapStateToProps: MapStateToProps<StateProps, OwnProps, State> = (state: State) => {
    const currentApp = state.app ? state.app.currentApp as ClientApp : undefined;
    const organization = state.org ? state.org.currentOrg : undefined;

    return {
        app: currentApp,
        organization: organization
    };
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(Breadcrumbs)
);
